import { Flowstep, ProviderType } from '@shared/types/flowstep';
import { AddressResolver } from '@shared/execution/types';
import { HubspotAddressResolver } from '@shared/providers/hubspot/hubspot-address-resolver';
import { WorkbookApi } from '@shared/execution/workbook-api';

export class AddressResolverFactory {
  getAddressResolver(flowstep: Flowstep, workbookApi: WorkbookApi<any>): AddressResolver {
    if (flowstep.provider === ProviderType.HS) {
      return new HubspotAddressResolver(workbookApi);
    }
    return new HubspotAddressResolver(workbookApi);
  }
}
